<template>
  <g>
    <path
      d="M12 0A12 12 0 110 12 12 12 0 0112 0zM9.89 18.38a8.16 8.16 0 008.21-8.21V9.8a5.91 5.91 0 001.44-1.5 5.86 5.86 0 01-1.66.45 2.88 2.88 0 001.27-1.6 5.85 5.85 0 01-1.83.7 2.89 2.89 0 00-5 1.98 2.65 2.65 0 00.08.66 8.19 8.19 0 01-5.95-3.02 2.88 2.88 0 00.9 3.85 2.84 2.84 0 01-1.3-.36V11a2.89 2.89 0 002.31 2.83 2.88 2.88 0 01-.76.1 2.75 2.75 0 01-.55-.05 2.88 2.88 0 002.7 2 5.8 5.8 0 01-3.59 1.24 5.25 5.25 0 01-.69-.05 8.04 8.04 0 004.42 1.31z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </g>
</template>
